(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .directive('errors', ['$state', 'Info', function($state, Info) {
            return {
                restrict: 'E',
                template: "<div class='info error' ng-repeat='error in errors'></span><span class='info-left error-left glyphicon glyphicon-remove'></span><span ng-bind-html='$sce.trustAsHtml(error)'></span></div>",
                link: function(scope, element, attrs) {
                    //If container is undefined
                    if (Info.errors[$state.current.name] == undefined)
                    //Initialize array
                        Info.errors[$state.current.name] = [];
                    //Give a reference
                    scope.errors = Info.errors[$state.current.name];
                }
            };
        }]);
})();
